import { render, staticRenderFns } from "./weixin-config-detail.vue?vue&type=template&id=53231c40&"
import script from "./weixin-config-detail.vue?vue&type=script&lang=js&"
export * from "./weixin-config-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports